"use strict";module.exports = function render(input, out) {
  var isComponent = !input.n;
  var shouldPreserve = !("i" in input) || input.i;
  var componentsContext = out.b_;
  var isHydrate =
  componentsContext && componentsContext.o_._W_;
  var ownerComponent = out._X_.r_;
  var referenceComponent = ownerComponent;
  var key = out._Y_;
  var checkKey = key;

  if (key[0] !== "@") {
    var parentComponent = componentsContext.n_.r_;
    if (ownerComponent !== parentComponent) {
      referenceComponent = parentComponent;
      checkKey += ":" + ownerComponent.id;
    }
  }

  var isPreserved =
  shouldPreserve && (
  isHydrate || referenceComponent.J_[checkKey]);

  if (isComponent) {
    out.bf(key, ownerComponent, shouldPreserve);

    if (!isPreserved && input.renderBody) {
      input.renderBody(out);
    }

    out.ef();
  } else {
    if (isPreserved) {
      if (input.b) {
        out._Z_.a__ = true;
      } else {
        out.beginElement("", null, key, ownerComponent);
        out._Z_.aa_ = true;
        out.endElement();
      }
    } else if (input.renderBody) {
      input.renderBody(out);
    }
  }
};